import { render, staticRenderFns } from "./operation.vue?vue&type=template&id=6058795f&scoped=true"
import script from "./operation.vue?vue&type=script&lang=js"
export * from "./operation.vue?vue&type=script&lang=js"
import style0 from "./operation.vue?vue&type=style&index=0&id=6058795f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6058795f",
  null
  
)

export default component.exports